






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { BatchDetailsDto } from '../../models/batch/BatchDetailsDto';
import BatchEventDetails from './batch-event-details.vue';
import { BatchService } from '../../service/BatchService';
import { DxButton, DxLoadIndicator } from 'devextreme-vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import DxToolbar from 'devextreme-vue/toolbar';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { Popup } from '@questelservices/common-vue';
import { DxTreeView } from 'devextreme-vue/tree-view';
import { BatchDataDeleteDto, BatchDataDeleteFileDto, BatchDataDeleteAgentInvoiceDto } from '../../models/batch/BatchDataDeleteDto';
import { BatchDataDeleteRequestDto } from '../../models/batch/BatchDataDeleteRequestDto';
import { confirm, alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

@Component({
  components: {
    BatchEventDetails,
    DxButton,
    DxLoadIndicator,
    DxLoadPanel,
    DxTreeView,
    DxToolbar,
    DxToolbarItem, 
    Popup
  }
})
export default class BatchDeleteData extends Vue {
  $refs: Vue['$refs'] & {      
    treeViewRef?: DxTreeView;
  } = {};

  @Prop({ default: false })
  showDialog!: boolean;

  @Prop({ required: true })
  batch!: BatchDetailsDto;

  @Watch("showDialog")
  async onShowPropChange(value: boolean, oldValue: boolean) {
    if (value) {
      this.loadData();
    }
  }
  
  get showingDialog() {
    return this.showDialog;
  }

  set showingDialog(value: boolean) {
    this.hidingDialog();
  }

  get treeView() {
    return (this.$refs.treeViewRef as any).instance;    
  }

  treeListItems: Array<any> = [];
  batchDataDeleteDto: any;
  deletingData: boolean = false;

  hidingDialog() {
    this.$emit("hidingDeleteBatchData");
    this.treeListItems = [];
  }

  generateTree(batchDataDeleteDto: BatchDataDeleteDto) {
    let fileItems: any[] = [];

    batchDataDeleteDto.Files.forEach(file => {
      let agentInvoiceItems: any[] = [];
      file.AgentInvoices.forEach(agentInvoice => {
        agentInvoiceItems.push({
          id: agentInvoice.ParentFileParseUploadFileId + agentInvoice.AgentId + agentInvoice.InvoiceNumber,
          text: `${agentInvoice.AgentName}, ${agentInvoice.InvoiceNumber}`,
          type: "Invoice",
          AgentId: agentInvoice.AgentId,
          InvoiceNumber: agentInvoice.InvoiceNumber,
          ParentFileParseUploadFileId: agentInvoice.ParentFileParseUploadFileId
        });
      });

      fileItems.push({
        id: file.FileParseUploadFileId,
        text: file.Filename,
        items: agentInvoiceItems,
        type: "File"
      });
    });

    this.treeListItems = [
      {
        id: batchDataDeleteDto.BatchId,
        text: batchDataDeleteDto.BatchName,
        items: fileItems,
        type: "Batch"
      }      
    ];
  }

  deleteData() {    
    if (this.$refs.treeViewRef) {    
      let selectedKeys = (this.$refs.treeViewRef as any).instance.getSelectedNodesKeys();

      if (selectedKeys.length === 0) {
        alert("Please select an item to delete", "Error");
        return;
      }

      confirm("Are you sure you want to delete the selected items?", "Confirm Delete")
        .then(result => {
          if (result) {
            let itemsArray = (this.$refs.treeViewRef as any).instance._dataAdapter._dataStructure;
            let selectedItems = itemsArray.filter((i: any) => i.internalFields.selected && selectedKeys.find((k: string) => k == i.internalFields.parentKey) == undefined);      
            
            let batchDataDeleteDto: BatchDataDeleteRequestDto = {
              ClientId: this.batch.ClientId,
              BatchId: undefined,
              FilesToDelete: [],
              AgentInvoicesToDelete: []
            };

            if (selectedKeys.some((k: string) => k == this.batch.BatchId)) {
              batchDataDeleteDto.BatchId = this.batch.BatchId;
            }
            else {
              let fileItems = selectedItems.filter((i: any) => i.type == "File"); 
              fileItems.forEach((file: any) => {
                let fileDto: BatchDataDeleteFileDto = {
                  FileParseUploadFileId: file.id,
                  Filename: file.text,
                  AgentInvoices: []
                };
                batchDataDeleteDto.FilesToDelete.push(fileDto);
              });

              let invoiceItems = selectedItems.filter((i: any) => i.type == "Invoice");
              invoiceItems.forEach((invoice: any) => {
                let invoiceDto: BatchDataDeleteAgentInvoiceDto = {
                  AgentId: invoice.AgentId,
                  AgentName: "",
                  InvoiceNumber: invoice.InvoiceNumber,
                  ParentFileParseUploadFileId: invoice.ParentFileParseUploadFileId            
                };
                batchDataDeleteDto.AgentInvoicesToDelete.push(invoiceDto);
              });    
            }

            let batchService = new BatchService();
            this.deletingData = true;

            batchService.deleteBatchData(batchDataDeleteDto)
              .then(result => {
                this.hidingDialog();
                notify("Batch data successfully deleted.", "success", 5000);
              })
              .catch(reason => {
                alert("Deleting batch data failed. Please contact support.", "Delete Failed");
              })
              .finally(() => {
                this.deletingData = false;
              });
          }          
        }
      );  
    }    
  }

  async loadData() {
    let batchService = new BatchService();
    this.batchDataDeleteDto = await batchService.getBatchDataDeleteTree(this.batch.BatchId)
      .then(result => this.generateTree(result))
  }

  constructor() {
    super();       
  }
}
